import { TextBoxPlusIcon } from './TextBoxPlusIcon';

/**
 * author: Michael Irigoyen
 * id 8979EEB0-B475-4229-A7D8-F5D48A58DB85
 * name text-box-plus
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-box-plus.svg
 * tags
 * - Files / Folders 
 */
export const FileDocumentBoxPlusIcon = TextBoxPlusIcon;
export default FileDocumentBoxPlusIcon